import axios from "axios";
import Vue from "vue";
import authHeader from "@/services/auth-header";
import config from "@/data/config";
import model from "@/data/model";

const API_URL = config.baseURL;
const myModel = model.baptis;

export const laporan = {
   namespaced: true,
   state: {
      data: [],
      cetak: [],
      item: { ...myModel },
   },
   getters: {
      // countAll: (state) => {return state.data.length},
      countAll(state) {
         return state.data.length;
      },
      getById: (state) => (id) => {
         return state.data.find((data) => data.id === id);
      },
   },
   actions: {
      async getJumlahUmat({ commit, rootState }) {
         rootState.isLoading = true;
         await axios
            .get(`${API_URL}laporan/umat_per_lingkungan`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("SET_DATA", response.data);
                  rootState.isLoading = false;
               },
               () => {
                  rootState.isLoading = false;
               }
            );
      },
      async getJumlahBaptis({ rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .post(`${API_URL}laporan/jumlah_baptis`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response.data);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async getJumlahKrisma({ rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .post(`${API_URL}laporan/jumlah_krisma`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response.data);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async getJumlahKomuni({ rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .post(`${API_URL}laporan/jumlah_komuni`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response.data);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async getJumlahPerkawinan({ rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .post(`${API_URL}laporan/jumlah_perkawinan`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response.data);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async getJumlahKematian({ rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .post(`${API_URL}laporan/jumlah_kematian`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response.data);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },      
      async getJumlahSingle({ rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .post(`${API_URL}laporan/jumlah_single`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response.data);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      setItem({ commit }, item) {
         commit("SET_ITEM", item);
      },
      resetItem({ commit }) {
         const item = { ...myModel };
         commit("SET_ITEM", item);
      },
   },
   mutations: {
      SET_DATA(state, data) {
         state.data = data;
      },
      SET_ITEM(state, item) {
         state.item = item;
      },
      PUSH_ITEM(state, item) {
         state.data.push(item);
      },
      CHANGE_ITEM(state, payload) {
         console.log(payload);
         const index = state.data.findIndex((item) => item.id === payload.id);
         if (index !== -1) {
            Vue.set(state.data, index, payload);
         }
      },
      REMOVE_ITEM(state, id) {
         var i = state.data.findIndex((data) => data.id == id);

         state.data.splice(i, 1);
      },
   },
};
